import {ApolloError, isApolloError, ServerError} from "@apollo/client";
import {setContext} from "@apollo/client/link/context";
import {onError} from "@apollo/client/link/error";
import {getAccessToken, getAccessTokenExpiresIn, setAccessToken} from "~/auth/functions";


function isNotAuthenticatedError(error: Error) {
    if (!isApolloError(error) || !error?.networkError) {
        return false;
    }
    return (error.networkError as (ServerError)).statusCode == 401;
}


export function createAuthLink() {
    return setContext((_, { headers }) => {
        headers = headers || {};
        const accessToken = getAccessToken();
        if (accessToken && getAccessTokenExpiresIn(accessToken) > 0) {
            headers['Authorization'] = `Bearer ${accessToken.accessToken}`;
        }

        return {
            headers
        };
    }).concat(onError(response => {
        const error = new ApolloError({
            ...response
        });

        const accessToken = getAccessToken();
        if (isNotAuthenticatedError(error) && accessToken && getAccessTokenExpiresIn(accessToken) > 0) {
            setAccessToken({
                ...accessToken,
                expiresAt: new Date(Date.now() - 5000)
            });
        }
    }));
}